import { DesignProp, LayoutProp } from "../PropCategories";

export const justifyContent = {
  prop: "style-attribute",
  name: "Distribution",
  nameI18n: "builder_ui.prop_type.styles.item_distribution",
  category: [DesignProp, LayoutProp],
  type: "justify-content",
  defaultValue: "flex-start",
  options: [
    {
      label: "Start",
      labelI18n: "builder_ui.prop_type.styles.item_distribution_types.start",
      value: "flex-start",
    },
    {
      label: "End",
      labelI18n: "builder_ui.prop_type.styles.item_distribution_types.end",
      value: "flex-end",
    },
    {
      label: "Center",
      labelI18n: "builder_ui.prop_type.styles.item_distribution_types.center",
      value: "center",
    },
    {
      label: "Space between",
      labelI18n:
        "builder_ui.prop_type.styles.item_distribution_types.space_between",
      value: "space-between",
    },
    {
      label: "Space around",
      labelI18n:
        "builder_ui.prop_type.styles.item_distribution_types.space_around",
      value: "space-around",
    },
    {
      label: "Space evenly",
      labelI18n:
        "builder_ui.prop_type.styles.item_distribution_types.space_evenly",
      value: "space-evenly",
    },
  ],
} as const;
